import React from 'react'
import { compose } from '@cbgms/base/utils/compose'
import { Switch } from 'react-router-dom'

import ThemeEdit from './Edit'
import ThemeNew from './New'

import List from './List'
import withRegionSwitchHandler from 'core/page/withRegionSwitchHandler'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_THEMES } from 'app-support/permissions/Permissions'
import { themesRoute, themesRouteEdit, themesRouteNew } from 'routes/routeNames'

const enhance = compose(withRegionSwitchHandler(themesRoute))

export const ThemeContainer: React.FC<{}> = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_THEMES} exact path={themesRouteNew} component={ThemeNew} />
    <PermissionRoute permission={PERMISSION_MANAGE_THEMES} exact path={themesRouteEdit} component={ThemeEdit} />
    <PermissionRoute permission={PERMISSION_MANAGE_THEMES} exact path={themesRoute} component={List} />
  </Switch>
)

export default enhance(ThemeContainer)
